
export default {
  namespaced: true,
  state: {
    campaign: null,
    selectedDonors: [],
    systemFields: [
      { id: 'PHONE', field_name: 'phone', enable: true },
      { id: 'TOTAL_PAID', field_name: 'total_paid', enable: true },
      { id: 'EMAIL', field_name: 'email', enable: true },
      { id: 'CREATED', field_name: 'created', enable: true },
      { id: 'GENDER', field_name: 'gender', enable: false },
      { id: 'AGE', field_name: 'age', enable: false },
      { id: 'NICKNAME', field_name: 'nickname', enable: false },
      { id: 'OCCUPATION', field_name: 'occoupation', enable: false },
      { id: 'MARITAL_STATUS', field_name: 'marital_status', enable: false },
      { id: 'INSTAGRAM', field_name: 'instagram', enable: false },
      { id: 'FACEBOOK', field_name: 'facebook', enable: false },
      { id: 'TWITTER', field_name: 'twitter', enable: false },
      { id: 'LINKEDIN', field_name: 'linkedin', enable: false },
      { id: 'TIKTOK', field_name: 'tiktok', enable: false }
    ],
    customFields: [],
  },
  mutations: {
    setCampaign (state, data) {
      state.campaign = data
    },
    resetCampaign (state) {
      state.campaign = null
    },
    selectDonors (state, data) {
      state.selectedDonors = data
    },
    resetSelectDonors (state) {
      state.selectedDonors = []
    },
    setCustomFields (state, fields) {
      state.customFields = fields ?? []
    }
  },
  getters: {
    getCampaign (state) {
      return state.campaign
    },
    getSelectedDonors (state) {
      return state.selectedDonors
    },
    getAllFields (state) {
      return [...state.systemFields, ...state.customFields]
    }
  }
}